import { QuestionBase } from './question-base';

export class IconBoxQuestion extends QuestionBase<string> {
  override controlType = 'iconbox';
}